import { HttpClient } from '@angular/common/http';
import {
  AfterViewInit,
  Component,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DataTableDirective } from 'angular-datatables';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subject } from 'rxjs';
import { Title } from '@angular/platform-browser';

import { FormatDataTableGlobal } from 'src/app/web/util/formatDataTable';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { ApiServiceProject } from '../../../apis/ApiServiceProject';
import { stageProject } from 'src/app/web/interfaces/project/stages/stageProject';
import { SummaryInfoDto } from 'src/app/web/interfaces/project/list/summaryInfoDto';
import { ErrorService } from 'src/app/shared/services/errors.service';

@Component({
  selector: 'app-project-stages',
  templateUrl: './project-stages.component.html',
  styleUrls: ['./project-stages.component.scss'],
})
export class ProjectStagesComponent
  implements AfterViewInit, OnDestroy, OnInit
{
  idProject: number;
  projectStages: stageProject[] = [];
  @ViewChild(DataTableDirective, { static: false })
  dtElement: DataTableDirective;
  dtTrigger = new Subject();
  dtOptions: DataTables.Settings = {};
  summaryInfoDto: SummaryInfoDto = {} as SummaryInfoDto;
  private apiService: ApiServiceProject;

  constructor(
    private http: HttpClient,
    private spinner: NgxSpinnerService,
    private route: ActivatedRoute,
    private router: Router,
    private titleService: Title,
    private errorService:ErrorService
  ) {
    this.titleService.setTitle('PDG - etapas del proyecto');
    this.route.params.subscribe((params) => {
      this.idProject = params['id'];
    });
  }

  ngOnInit(): void {

    this.dtOptions = FormatDataTableGlobal();
    this.apiService = new ApiServiceProject(this.http);

    this.summaryInfoDto.title = localStorage.getItem("title");

    this.spinner.show();
    this.apiService
      .getService('project-view-stage?id_project=' + this.idProject)
      .subscribe({
        next: (rs: any) => {
          if (rs.code == null) {
            // si la respuesta no tiene error pero no tiene data se manda un mensaje de error y se retorna al home
            if (rs == '' || rs == null) {
              this.spinner.hide();
              Swal.fire({
                title: 'No se encontraron registros',
                text: '',
                icon: 'info',
                confirmButtonText: 'Aceptar',
                heightAuto: false
              }).then((res) => {
                if (res.isConfirmed || res.isDismissed) {
                  this.router.navigate(['home']);
                }
              });
            }
            this.projectStages = rs;
            this.spinner.hide();
            this.rerender();
          } else {
            this.spinner.hide();
            Swal.fire({
            title:  rs.error,
            text: '',
            icon: 'error',
            heightAuto: false
            });
          }
        },
        error: (error) => {
          this.errorService.error(error);
        },
      });

  }
  stageDelete(id:any){
      Swal.fire({
                title: 'Eliminar',
                text: '¿Desea eliminar registro?',
                icon: 'warning',
                showCancelButton:true,
                confirmButtonText: 'Aceptar',
                cancelButtonText:"No, cancelar",
                heightAuto: false
              }).then((res) => {
                if (res.isConfirmed) {
                  this.spinner.show()
                  this.apiService.deleteService('project-stage-delete?id=' + id).subscribe({
                    next: (rs: any) => {
                      if (rs) {
                        this.spinner.hide();
                        Swal.fire({title:'Exito!',text: 'Se ha eliminado con exito!',icon: 'success',heightAuto: false}).then(()=>{location.reload()})
                        
                      } else {
                          this.spinner.hide();
                          Swal.fire({
                          title:  rs.error,
                          text: '',
                          icon: 'error',
                          heightAuto: false
                          }); } },
                    error: (error) => {
                      this.errorService.error(error);
                    },});
                }
                else if ( res.dismiss === Swal.DismissReason.cancel){
                  Swal.fire({
                    title: 'Cancelado',
                    text: 'Operación cancelada.',
                    icon: 'error',
                    heightAuto: false
                    })

                }
              });
    
    
  }

  stagesEdit(item:any, id: any){

    localStorage.setItem("title",  this.summaryInfoDto.title);
    this.router.navigateByUrl('/pdg/project/'+id+'/stages/'+ item.id +'/edit');
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next();
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  rerender(): void {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy();
      this.dtTrigger.next();
    });
  }
}
